import { cn } from '@/lib/utils';

export interface TabItem {
  id: string;
  label: string;
  icon?: React.ComponentType<{ className?: string }>;
  disabled?: boolean;
}

interface TabBarProps {
  tabs: TabItem[];
  activeTab: string;
  onChange: (id: string) => void;
  className?: string;
}

export function TabBar({ tabs, activeTab, onChange, className }: TabBarProps) {
  if (tabs.length <= 1) return null;

  return (
    <div className={cn('overflow-x-auto rounded-xl border border-slate-200 bg-white px-2 py-1.5 dark:border-border dark:bg-card', className)}>
      <div className="flex gap-1">
        {tabs.map(tab => (
          <button
            key={tab.id}
            type="button"
            onClick={() => onChange(tab.id)}
            disabled={tab.disabled}
            className={cn(
              'flex items-center gap-1.5 whitespace-nowrap rounded-md px-3 py-1.5 text-xs font-medium transition',
              activeTab === tab.id
                ? 'bg-brand-500 text-white shadow-sm'
                : 'text-ink-500 hover:bg-slate-100 dark:hover:bg-secondary',
              tab.disabled && 'cursor-not-allowed opacity-50',
            )}
          >
            {tab.icon && <tab.icon className="h-3.5 w-3.5" />}
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
}
